// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@7.1.3_@rspack+core@1.7.6_webpack@5.99.9/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@7.1.3_@rspack+core@1.7.6_webpack@5.99.9/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:is(.white-bg, .light-bg),
:is(a:where(:any-link:not(.button))):where(:not(:is(.white-bg, .light-bg, .dark-bg) :is(a:where(:any-link:not(.button)), .d-anchor))) {
  --anchor-bg-hover: var(--color-gray-02);
  --anchor-bg-active: var(--color-gray-01);
  --anchor-color: var(--link-color);
  --anchor-color-hover: var(--link-color);
  --anchor-color-visited: var(--visited-link-color);
}

.dark-bg {
  --anchor-color: var(--color-white-08);
  --anchor-color-hover: var(--color-white-08);
  --anchor-color-visited: var(--color-white-08);
  --anchor-bg-hover: var(--color-white-03);
  --anchor-bg-active: var(--color-white-01);
}

a:where(:any-link:not(.button)),
.d-anchor {
  background-color: transparent;
  border: none;
  border-radius: var(--default-outline-radius);
  color: var(--color);
  cursor: pointer;
  flex-shrink: 0;

  /* Inherit these properties for button.d-anchor. (<a> does this by default.) */
  font-family: inherit;
  font-size: inherit;
  font-weight: inherit;
  line-height: inherit;
  min-height: 0;
  min-width: 0;
  outline: none;
  -webkit-text-decoration: underline 0.075em;
          text-decoration: underline 0.075em;
  text-underline-offset: 0.175em;
  transition:
    background-color var(--default-transition),
    outline var(--default-transition);

  &::-moz-focus-inner {
    border: 0;
  }

  &:visited {
    color: var(--color-visited);
  }

  &:hover {
    background-color: var(--anchor-bg-hover);
    color: var(--color-hover);
  }

  &:active {
    background-color: var(--anchor-bg-active);
  }

  &:disabled {
    color: var(--disabled-color);
    pointer-events: none;
  }
}

button.d-anchor {
  padding: 0;
}

.is-keynav {
  & a:where(:any-link:not(.button)):focus,
  & .d-anchor:focus {
    outline: var(--default-outline);
    outline-offset: var(--default-outline-offset);
  }
}

/* Less prominent link variant: no text decoration, and appears blue on hover only. */

.d-anchor-light,
  /* This style was used already before this anchor variant was defined. In order not to have to duplicate the style
  while also not to have have to retrofit all places where it was already used, we provide this special context class.
  Most new usages should probably assign the "d-anchor-light" class on the links themselves, for more flexibility. */
.d-anchor-light-context :is(a:where(:any-link:not(.button)), .d-anchor) {
  --anchor-bg-hover: transparent;
  --anchor-bg-active: transparent;
  --anchor-color: unset;
  --anchor-color-visited: unset;

  &:not(:hover) {
    text-decoration: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/ui/anchor.css"],"names":[],"mappings":"AAAA;;EAEE,uCAAuC;EACvC,wCAAwC;EACxC,iCAAiC;EACjC,uCAAuC;EACvC,iDAAiD;AACnD;;AAEA;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,6CAA6C;EAC7C,wCAAwC;EACxC,yCAAyC;AAC3C;;AAEA;;EAEE,6BAA6B;EAC7B,YAAY;EACZ,4CAA4C;EAC5C,mBAAmB;EACnB,eAAe;EACf,cAAc;;EAEd,8EAA8E;EAC9E,oBAAoB;EACpB,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,YAAY;EACZ,aAAa;EACb,0CAAkC;UAAlC,kCAAkC;EAClC,8BAA8B;EAC9B;;qCAEmC;;EAEnC;IACE,SAAS;EACX;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,wCAAwC;IACxC,yBAAyB;EAC3B;;EAEA;IACE,yCAAyC;EAC3C;;EAEA;IACE,4BAA4B;IAC5B,oBAAoB;EACtB;AACF;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE;;IAEE,+BAA+B;IAC/B,6CAA6C;EAC/C;AACF;;AAEA,qFAAqF;;AACrF;;;;;EAKE,8BAA8B;EAC9B,+BAA+B;EAC/B,qBAAqB;EACrB,6BAA6B;;EAE7B;IACE,qBAAqB;EACvB;AACF","sourcesContent":[":is(.white-bg, .light-bg),\n:is(a:where(:any-link:not(.button))):where(:not(:is(.white-bg, .light-bg, .dark-bg) :is(a:where(:any-link:not(.button)), .d-anchor))) {\n  --anchor-bg-hover: var(--color-gray-02);\n  --anchor-bg-active: var(--color-gray-01);\n  --anchor-color: var(--link-color);\n  --anchor-color-hover: var(--link-color);\n  --anchor-color-visited: var(--visited-link-color);\n}\n\n.dark-bg {\n  --anchor-color: var(--color-white-08);\n  --anchor-color-hover: var(--color-white-08);\n  --anchor-color-visited: var(--color-white-08);\n  --anchor-bg-hover: var(--color-white-03);\n  --anchor-bg-active: var(--color-white-01);\n}\n\na:where(:any-link:not(.button)),\n.d-anchor {\n  background-color: transparent;\n  border: none;\n  border-radius: var(--default-outline-radius);\n  color: var(--color);\n  cursor: pointer;\n  flex-shrink: 0;\n\n  /* Inherit these properties for button.d-anchor. (<a> does this by default.) */\n  font-family: inherit;\n  font-size: inherit;\n  font-weight: inherit;\n  line-height: inherit;\n  min-height: 0;\n  min-width: 0;\n  outline: none;\n  text-decoration: underline 0.075em;\n  text-underline-offset: 0.175em;\n  transition:\n    background-color var(--default-transition),\n    outline var(--default-transition);\n\n  &::-moz-focus-inner {\n    border: 0;\n  }\n\n  &:visited {\n    color: var(--color-visited);\n  }\n\n  &:hover {\n    background-color: var(--anchor-bg-hover);\n    color: var(--color-hover);\n  }\n\n  &:active {\n    background-color: var(--anchor-bg-active);\n  }\n\n  &:disabled {\n    color: var(--disabled-color);\n    pointer-events: none;\n  }\n}\n\nbutton.d-anchor {\n  padding: 0;\n}\n\n.is-keynav {\n  & a:where(:any-link:not(.button)):focus,\n  & .d-anchor:focus {\n    outline: var(--default-outline);\n    outline-offset: var(--default-outline-offset);\n  }\n}\n\n/* Less prominent link variant: no text decoration, and appears blue on hover only. */\n.d-anchor-light,\n  /* This style was used already before this anchor variant was defined. In order not to have to duplicate the style\n  while also not to have have to retrofit all places where it was already used, we provide this special context class.\n  Most new usages should probably assign the \"d-anchor-light\" class on the links themselves, for more flexibility. */\n.d-anchor-light-context :is(a:where(:any-link:not(.button)), .d-anchor) {\n  --anchor-bg-hover: transparent;\n  --anchor-bg-active: transparent;\n  --anchor-color: unset;\n  --anchor-color-visited: unset;\n\n  &:not(:hover) {\n    text-decoration: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
var ___CSS_LOADER_STYLE_SHEET___ = new CSSStyleSheet();
___CSS_LOADER_STYLE_SHEET___.replaceSync(___CSS_LOADER_EXPORT___.toString());
export default ___CSS_LOADER_STYLE_SHEET___;
